










import { defineComponent, ref, watch } from '@nuxtjs/composition-api';
import { useCmsBlocks } from "~/components/czar/customTickerBar/cmsBlocks";
import { storeToRefs } from 'pinia';
import { useRouter } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'TextTickerBlock',
  components: {

  },
  props: {
    
  },
  setup(props) {
    const cmsBlocks = useCmsBlocks();
    const { items } = storeToRefs(cmsBlocks);
    const isLoading = ref(true);
    const error = ref(false);
    const router = useRouter();

    const fetchContent = async () => {
      try {
        var queryVariables = { identifiers: ["custom-ticker"] };
        await cmsBlocks.fetchCmsBlock(queryVariables);
        isLoading.value = false;
        
        // Check if items exist and have content
        if (!items.value || items.value.length === 0) {
          error.value = true;
          return;
        }

        // Check if content is empty
        const hasContent = items.value.some(block => block.content && block.content.trim());
        if (!hasContent) {
          error.value = true;
          return;
        }

        error.value = false;
      } catch (err) {
        console.error('Error fetching CMS block:', err);
        error.value = true;
        isLoading.value = false;
      }
    };

    // Initial fetch
    fetchContent();

    // Watch for changes in the items store
    watch(items, () => {
      if (items.value && items.value.length > 0) {
        const hasContent = items.value.some(block => block.content && block.content.trim());
        error.value = !hasContent;
      }
    });

    const handleLinkClick = (event) => {
      const anchor = event.target.closest('a');
      if (anchor) {
        event.preventDefault();
        const href = anchor.getAttribute('href');
        if (href) {
          router.push(href);
        }
      }
    };

    return {
      items,
      isLoading,
      error,
      handleLinkClick
    };
  },
});
